module.exports = __webpack_public_path__ + "img/1.12ce9189.jpg";